import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "../assets/images/logo.png";
import LanguageSwitcher from "./LanguageSwitcher";

const Banner = ({ image, title, subtitle, desc, onOpenSidebar }) => {
  const [headerVisible, setHeaderVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const onScroll = () => setHeaderVisible(window.scrollY >= 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <div
        className={`fixed h-[64px] sm:h-[72px] md:h-[82px] top-0 left-0 right-0 z-30 flex items-center transition-all duration-500 ${
          headerVisible ? "opacity-0 pointer-events-none" : "opacity-100"
        }`}
      >
        <div
          className="relative h-full w-full mx-auto px-4 sm:px-6 flex items-center justify-between"
          style={{ maxWidth: "1320px" }}
        >
          <button
            onClick={onOpenSidebar}
            aria-label={t("nav.openMenu")}
            className="flex flex-col gap-[4px] sm:gap-[5px] group"
          >
            <span className="block w-5 sm:w-6 md:w-7 h-0.5 bg-white group-hover:opacity-70 transition-opacity duration-200" />
            <span className="block w-5 sm:w-6 md:w-7 h-0.5 bg-white group-hover:opacity-70 transition-opacity duration-200" />
            <span className="block w-5 sm:w-6 md:w-7 h-0.5 bg-white group-hover:opacity-70 transition-opacity duration-200" />
          </button>

          <div className="flex justify-center items-center gap-2 sm:gap-3">
            <img
              src={logo}
              alt=""
              className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20"
            />
            <Link
              to="/"
              className="text-white text-sm sm:text-base md:text-xl font-bold uppercase tracking-wider sm:tracking-widest hover:opacity-70 transition-opacity duration-200"
            >
              {t("header.brand")}
            </Link>
          </div>
          <LanguageSwitcher className="text-white" />
        </div>
      </div>

      <div
        style={{
          backgroundImage: `url(${image})`,
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          backgroundBlendMode: "darken",
        }}
        className="relative flex items-center justify-center min-h-screen bg-cover bg-top md:bg-fixed px-4"
      >
        <div>
          <div className="text-center text-slate-300 text-xl sm:text-3xl md:text-4xl font-bold uppercase tracking-[0.25rem] sm:tracking-[0.4rem] md:tracking-[0.5rem]">
            {title}
          </div>
          <div className="text-center font-bold text-white text-base sm:text-xl md:text-3xl mt-3 sm:mt-4">
            {subtitle}
          </div>
          <div className="text-center text-gray-300 text-sm sm:text-lg md:text-xl font-light mt-3 sm:mt-4">
            {desc}
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
